//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectBodyList.js";
import "../no/SelectPointList.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Angle",0,"Expression",0],[1,"ElectrodeBodies",0,"SelectBodyList",0],[1,"OrbitPointList",0,"SelectPointList",0],[1,"OrbitSize",0,"Expression",0],[0,"OrbitType",1,0],[0,"PointSpecify",1,"Point",0],[1,"SelectElectrodeBlock",0,"SelectBodyList",1],[1,"SelectPoints",0,"SelectPointList",1],[1,"SparkGap",0,"Expression",0]],[],[]];
SPLM.Tooling.UndersizeBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.UndersizeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.UndersizeBuilder.Orbit = Object.freeze({
    "Circular" : "Circular", "Square" : "Square", "Triangle" : "Triangle", "Spherical" : "Spherical", "Points" : "Points"});

export default SPLM;